import { Component } from "react";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import CorporateMemberServices from "../../../services/axiosServices/apiServices/CorporateMemberServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import moment from "moment";
import MultiSelectDropdown from "../../../components/inputs/MultiSelectDropdown";
import { saveAs } from "file-saver";
import ValidationText from "../../../utils/validation/ValidationText"
import { CommonValidationMessages } from '../../../utils/Messages'
import Option from "../../../components/dropdown/multiSelectDropdownOption/MultiSelectOption";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import { validate, isValidForm } from '../../../utils/validation/CommonValidator'
export default class AllMemberReports extends Component {
  constructor(props) {
    super(props);
    this.corporateMemberServices = new CorporateMemberServices();
    this.swalServices = new SwalServices();
    this.state = {
      isLoading: false,
      validState: {
        isValid: true,
        error: {},
      },
      validationRule: {

        memberStatus: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace("{0}", "member Status"),
          },
        ], memberType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace("{0}", "Member Type"),
          },
        ],

      },
      startDate: "",
      endDate: "",
      //Dropdown Arrays
      status: [],
      membershipType: [],
      countries: [],
      serviceType: [],
      industriesServed: [],
      groupAsset: [],
      businessInterest: [],
      totalGroupAsset: [],
      marketInterest: [],
      selectedFilters: {
        MemberStatus: null,
        MemberType: null,
        Country: null,
        totalGroupAsset: null,
        businessInterest: null,
        marketInterest: null,
      },
      temp: {
        memberType: [],
        memberStatus: [],
        countriesdata: [],
        totalGroupAssetdata: [],
        businessInterestdata: [],
        marketInterestdata: [],
        startDate: "",
        endDate: ""
      },
      companyInformation: {
        isAllCompanyInformation: false,
        companyName: false,
        membershipTypeId: false,
        mailingAddress: false,
        mailingAddressLine1: false,
        mailingAddressLine2: false,
        mailingAddressLine3: false,
        mailingAddressCountry: false,
        mailingAddressPostalCode: false,
        registeredOfficeAddressLine1: false,
        registeredOfficeAddressLine2: false,
        registeredOfficeAddressLine3: false,
        registeredOfficeCountry: false,
        registeredOfficePostalCode: false,
        registeredAddress: false,
        postalCode: false,
        companyNumber: false,
        companyTelephone: false,
        incorporationDate: false,
        organisationWebsite: false,
        employmentSize: false,
        companyAdminEmail: false,
        uen: false,
        statusId: false,
        countries: false,
        subscriptionStartDate: false,
        subscriptionEndDate: false,
        issuedCapital: false,
        paidUpCapital: false,
        shareholdersEquities: false,
        realEstateActivitiesID: false,
        realEstateSpecification:false,
        overseasOfficesID: false,
        totalGroupAssetID: false,
        employmentSizeID: false,
        companyInterestsID: false,
        howDidYouHearAboutUsID: false,

      },
      representatives: {
        selectAll: false,
      },

      authorizedRepresentativeDetails: {
        authorizedRepresentative: false,
        authorizedFirstName: false,
        authorizedLastName: false,
        authorizedDesignation: false,
        authorizedJobPosition: false,
        authorizedEmail: false,
      },

      representatives: {
        mainRepresentative: false,
        alterRepresentative: false,
        authorizedRepresentative: false,
        isAllRepresentative: false,
      },

      resources: {
        isAllResources: false,
        projectCompleted: false,
        inProgressProjects: false,
        boardOfDirectors: false,
        topManagement: false,
      },

      mainepResentativesDetailes: {
        isAllCompanyInformation: false,
        repFirstName: false,
        repLastName: false,
        repDesignation: false,
        repJobPosition: false,
        respEmail: false,
      },
      alternativeRepresentativeDetailes: {
        alterRepresentative: false,
        altFirstName: false,
        altLastName: false,
        altDesignation: false,
        altJobPosition: false,
        altEmail: false,
      },
      ordinaryProjectComplicatedDetailes: {
        isAllOrdinaryInformation: false,
        isProjectCompletedOfOrdinary: false,
        isProjectDeveloperLicenseNo: false,
        isOrdinaryProjectName: false,
        isOrdinaryProjectLocation: false,
        isProjectDateOfTOP: '',
        isProjectDevelopmentTypeID: false,
      },
      ordinaryProjectPipelineDetailes: {
        inProgressProjects: false,
        isProjectCompleted: false,
        developerLicenseNo: false,
        processrojectName: false,
        projectLocation: false,
        dateOfTOP: '',
        developmentTypeID: false,
      },
      boardOfDirectiveDetailes: {
        isBoradOfDirective: false,
        nameofDirector: false,
        desigantionOfDirector: false,
      },
      topManagementDetailes: {
        isTopManagement: false,
        nameofTopDirective: false,
        desigantionOfTopDirective: false,
      }
    };
  }
  componentDidMount() {
    this.getAllDropdownsForAllMemberReport();
  }

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.temp,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };
  getAllMembersReportsDetail = () => {

    let nameOfCountries = [];
    let countriesList = [];
    let listofallCountries = "";
    let nameOfGroupAsset = [];
    let assetsList = [];
    let listofallGroupAsset = "";
    let nameOfbusinessIntrest = [];
    let businessList = [];
    let listofallBusinessIntrest = "";
    let marketList = [];
    let nameOfmarketIntrest = [];
    let listofallMarketIntrest = "";
    let request = {};

    if (this.state.temp.memberStatus.length > 0) {
      var arr1 = this.state.temp.memberStatus.map(function (item) { delete item.bad; return item.value; });
      request.memberStatus = arr1.join([","]);
    }
    if (this.state.temp.memberType.length > 0) {
      var arr1 = this.state.temp.memberType.map(function (item) { delete item.bad; return item.value; });
      request.memberType = arr1.join([","]);
    }

    if (this.state.temp.countriesdata.length === 0) {
      countriesList = this.state.countries;
      nameOfCountries = countriesList.filter((drp) => drp.value).map((drp) => drp.value);
      listofallCountries = nameOfCountries.join([","]);
      request.countries = listofallCountries;
    } else {
      var arr1 = this.state.temp.countriesdata.map(function (item) { delete item.bad; return item.value; });
      request.countries = arr1.join([","]);
    }
    if (this.state.temp.totalGroupAssetdata.length === 0) {
      assetsList = this.state.groupAsset;
      nameOfGroupAsset = assetsList.filter((drp) => drp.value).map((drp) => drp.value);
      listofallGroupAsset = nameOfGroupAsset.join([","]);
      request.totalGroupAsset = listofallGroupAsset;
    } else {
      var arr1 = this.state.temp.totalGroupAssetdata.map(function (item) { delete item.bad; return item.value; });
      request.totalGroupAsset = arr1.join([","]);
    }
    if (this.state.temp.businessInterestdata.length === 0) {
      businessList = this.state.businessInterest;
      nameOfbusinessIntrest = businessList.filter((drp) => drp.value).map((drp) => drp.value);
      listofallBusinessIntrest = nameOfbusinessIntrest.join([","]);
      request.businessInterest = listofallBusinessIntrest;
    } else {
      var arr1 = this.state.temp.businessInterestdata.map(function (item) { delete item.bad; return item.value; });
      request.businessInterest = arr1.join([","]);
    }
    if (this.state.temp.marketInterestdata.length === 0) {
      marketList = this.state.marketInterest;
      nameOfmarketIntrest = businessList.filter((drp) => drp.value).map((drp) => drp.value);
      listofallMarketIntrest = nameOfmarketIntrest.join([","]);
      request.marketInterest = listofallMarketIntrest;
    } else {
      var arr1 = this.state.temp.marketInterestdata.map(function (item) { delete item.bad; return item.value; });
      request.marketInterest = arr1.join([","]);
    }

    request.companyUen = this.state.companyInformation.uen === true ? "1" : "0";
    request.companyName = "1";
    request.statusId = this.state.companyInformation.statusId === true ? 1 : 0;
    request.membershipTypeId = this.state.companyInformation.membershipTypeId === true ? 1 : 0;
    request.mailingAddress = this.state.companyInformation.mailingAddress === true ? "1" : "0";
    request.mailingAddressLine1 = this.state.companyInformation.mailingAddressLine1 ? "1" : "0";
    request.mailingAddressLine2 = this.state.companyInformation.mailingAddressLine2 ? "1" : "0";
    request.mailingAddressLine3 = this.state.companyInformation.mailingAddressLine3 ? "1" : "0";
    request.mailingAddressCountry = this.state.companyInformation.mailingAddressCountry ? "1" : "0";
    request.mailingAddressPostalCode = this.state.companyInformation.mailingAddressPostalCode ? "1" : "0";

    request.registeredAddress = this.state.companyInformation.registeredAddress === true ? "1" : "0";
    request.registeredOfficeAddressLine1 = this.state.companyInformation.registeredOfficeAddressLine1 ? "1" : "0";
    request.registeredOfficeAddressLine2 = this.state.companyInformation.registeredOfficeAddressLine2 ? "1" : "0";
    request.registeredOfficeAddressLine3 = this.state.companyInformation.registeredOfficeAddressLine3 ? "1" : "0";
    request.registeredOfficeCountry = this.state.companyInformation.registeredOfficeCountry ? "1" : "0";
    request.registeredOfficePostalCode = this.state.companyInformation.registeredOfficePostalCode ? "1" : "0";

    request.postalCode = this.state.companyInformation.postalCode === true ? "1" : "0";
    request.registeredCountryId = this.state.companyInformation.countries === true ? "1" : "0";
    request.mailingCountryId = this.state.companyInformation.mailingCountryId === true ? 1 : 0;
    request.companyTelephone = this.state.companyInformation.companyTelephone === true ? 1 : 0;
    request.companyAdminEmail = this.state.companyInformation.companyAdminEmail === true ? "1" : "0";
    request.incorporationDate = this.state.companyInformation.incorporationDate === true ? "2024-11-01 12:05:10.000" : null;
    request.employmentSize = this.state.companyInformation.employmentSize === true ? "1" : "0";
    request.companyWebsite = this.state.companyInformation.organisationWebsite === true ? "1" : "0";
    request.issuedCapital = this.state.companyInformation.issuedCapital === true ? "1" : "0";
    request.paidUpCapital = this.state.companyInformation.paidUpCapital === true ? "1" : "0";
    request.shareholdersEquities = this.state.companyInformation.shareholdersEquities === true ? "1" : "0";
    request.realEstateActivitiesID = this.state.companyInformation.realEstateActivitiesID === true ? "1" : "0";
    request.realEstateSpecification = this.state.companyInformation.realEstateSpecification === true ? "1" : "0";
    request.overseasOfficesID = this.state.companyInformation.overseasOfficesID === true ? "1" : "0";
    request.totalGroupAssetID = this.state.companyInformation.totalGroupAssetID === true ? "1" : "0";
    request.employmentSizeID = this.state.companyInformation.employmentSizeID === true ? "1" : "0";
    request.companyInterestsID = this.state.companyInformation.companyInterestsID === true ? "1" : "0";
    request.howDidYouHearAboutUsID = this.state.companyInformation.howDidYouHearAboutUsID === true ? "1" : "0";

    request.membershipAdmissionFrom = this.state.temp.startDate === '' ? '1900-01-01 00:00:00.000' : this.state.temp.startDate;
    request.membershipAdmissionTo = this.state.temp.endDate === '' ? '1900-01-01 00:00:00.000' : this.state.temp.endDate;
    //representative
    request.repFirstName = this.state.mainepResentativesDetailes.repFirstName === true ? "1" : "0";
    request.repLastName = this.state.mainepResentativesDetailes.repLastName === true ? "1" : "0";
    request.repDesignation = this.state.mainepResentativesDetailes.repDesignation === true ? "1" : "0";
    request.repJobPosition = this.state.mainepResentativesDetailes.repJobPosition === true ? "1" : "0";
    request.respEmail = this.state.mainepResentativesDetailes.respEmail === true ? "1" : "0";
    //Alternative representative
    request.altFirstName = this.state.alternativeRepresentativeDetailes.altFirstName === true ? "1" : "0";
    request.altLastName = this.state.alternativeRepresentativeDetailes.altLastName === true ? "1" : "0";
    request.altDesignation = this.state.alternativeRepresentativeDetailes.altDesignation === true ? "1" : "0";
    request.altJobPosition = this.state.alternativeRepresentativeDetailes.altJobPosition === true ? "1" : "0";
    request.altEmail = this.state.alternativeRepresentativeDetailes.altEmail === true ? "1" : "0";

    //authrized representative
    request.authorizedFirstName = this.state.authorizedRepresentativeDetails.authorizedFirstName === true ? "1" : "0";
    request.authorizedLastName = this.state.authorizedRepresentativeDetails.authorizedLastName === true ? "1" : "0";
    request.authorizedDesignation = this.state.authorizedRepresentativeDetails.authorizedDesignation === true ? "1" : "0";
    request.authorizedJobPosition = this.state.authorizedRepresentativeDetails.authorizedJobPosition === true ? 1 : 0;
    request.authorizedEmail = this.state.authorizedRepresentativeDetails.authorizedEmail === true ? "1" : "0";


    // request.memberType = this.state.selectedFilters.MemberType;
    // request.memberStatus = this.state.selectedFilters.MemberStatus;

    // request.subscriptionStartDate =this.state.companyInformation.subscriptionStartDate === true ? "2024-11-01 12:05:10.000" : "2024-12-01 12:05:10.000";
    // request.subscriptionEndDate =this.state.companyInformation.subscriptionEndDate === true ? "2024-11-01 12:05:10.000" : "2024-12-01 12:05:10.000"

    //Ordinory Project 
    //request.isProjectCompletedOfOrdinary = this.state.ordinaryProjectComplicatedDetailes.isProjectCompletedOfOrdinary === true ? 1 : 0;
    request.isProjectDeveloperLicenseNo = this.state.ordinaryProjectComplicatedDetailes.isProjectDeveloperLicenseNo === true ? "1" : "0";
    request.isOrdinaryProjectName = this.state.ordinaryProjectComplicatedDetailes.isOrdinaryProjectName === true ? "1" : "0";
    request.isOrdinaryProjectLocation = this.state.ordinaryProjectComplicatedDetailes.isOrdinaryProjectLocation === true ? "1" : "0";
    request.isProjectDateOfTOP = this.state.ordinaryProjectComplicatedDetailes.isProjectDateOfTOP === true ? "2024-11-01 12:05:10.000" : null;
    request.isProjectDevelopmentTypeID = this.state.ordinaryProjectComplicatedDetailes.isProjectDevelopmentTypeID === true ? "1" : "0";

    //Ordinory pipeline
    //request.isProjectCompleted = this.state.ordinaryProjectPipelineDetailes.isProjectCompleted === true ? 1 : 0;
    request.developerLicenseNo = this.state.ordinaryProjectPipelineDetailes.developerLicenseNo === true ? "1" : "0";
    request.projectName = this.state.ordinaryProjectPipelineDetailes.processrojectName === true ? "1" : "0";
    request.projectLocation = this.state.ordinaryProjectPipelineDetailes.projectLocation === true ? "1" : "0";
    request.dateOfTOP = this.state.ordinaryProjectPipelineDetailes.dateOfTOP === true ? "2024-11-01 12:05:10.000" : null;
    request.developmentTypeID = this.state.ordinaryProjectPipelineDetailes.developmentTypeID === true ? "1" : "0";

    //Borad Of Directors
    request.nameofDirector = this.state.boardOfDirectiveDetailes.nameofDirector === true ? "1" : "0";
    request.desigantionOfDirector = this.state.boardOfDirectiveDetailes.desigantionOfDirector === true ? "1" : "0";


    //Top Management
    request.nameofTopDirective = this.state.topManagementDetailes.nameofTopDirective === true ? "1" : "0";
    request.desigantionOfTopDirective = this.state.topManagementDetailes.desigantionOfTopDirective === true ? "1" : "0";

    // request.subscriptionStartDate = this.state.companyInformation.subscriptionStartDate === '' ? "2024-11-01 12:05:10.000" : "2024-12-01 12:05:10.000";
    // request.subscriptionEndDate = this.state.companyInformation.subscriptionEndDate === '' ? "2024-11-01 12:05:10.000" : "2024-12-01 12:05:10.000";
    let isValidateAllFields = this.isValidateAllFields()

    if (isValidateAllFields === true) {
      this.setState({ isLoading: true }, () => {
        this.corporateMemberServices
          .getAllMembersReportsDetail(request)
          .then((response) => {
            if (response.status === 200 && response.data != null) {
              const blob = new Blob([response.data]);

              const reader = new FileReader();

              reader.onload = function (e) {
                const buffer = new Uint8Array(e.target.result);

                const isZip = buffer[0] === 0x50 && buffer[1] === 0x4B;

                if (!isZip) {
                  this.swalServices.Alert("Data is not available")
                  this.setState({ isLoading: false })
                  return;
                }

                saveAs(blob, "AllMembershipReport_.xlsx");
                this.setState({ isLoading: false })

              }.bind(this);

              reader.onerror = function () {
                this.swalServices.Error("Failed to read the downloaded file.");
              }.bind(this);

              reader.readAsArrayBuffer(blob);
            }
            else {
              this.swalServices.Error(response.message);
            }
          });
      });
    }
  };
  getAllDropdownsForAllMemberReport = () => {
    this.corporateMemberServices
      .getAllDropdownsForAllMemberReport()
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          // let status = response.responseItem.responseContent.filter(
          //   (drp) => drp.dropdownName === "MemberReportStatus"
          // );

          let status = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "MemberReportStatus")
            .map((item) => ({ value: item.id, label: item.name }));

          let membershipType = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "MembershipTypes")
            .map((item) => ({ value: item.id, label: item.name }));


          // let membershipType = response.responseItem.responseContent.filter(
          //   (drp) => drp.dropdownName === "MembershipTypes"
          // );

          let countries = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "Countries")
            .map((item) => ({ value: item.id, label: item.name }));

          let serviceType = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "ServicesType")
            .map((item) => ({ value: item.id, label: item.name }));

          let industriesServed = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "IndustriesServed")
            .map((item) => ({ value: item.id, label: item.name }));
          let groupAsset = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "TotalGroupAssetsId")
            .map((item) => ({ value: item.id, label: item.name }));
          let businessInterest = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "BusinessInterest")
            .map((item) => ({ value: item.id, label: item.name }));
          let marketInterest = response.responseItem.responseContent
            .filter((drp) => drp.dropdownName === "MarketInterest")
            .map((item) => ({ value: item.id, label: item.name }));

          this.setState({
            status: status,
            membershipType: membershipType,
            countries: countries,
            groupAsset: groupAsset,
            marketInterest: marketInterest,
            businessInterest: businessInterest
          });
        } else {
          this.swalServices.Error(response.message);
        }
      });
  };

  handleChange = (id, drpIdentity) => {
    this.setState((prevState) => ({
      selectedFilters: {
        ...prevState.selectedFilters,
        [drpIdentity]: id,
      },
    }));
  };

  handleChangeForCompanyInformation(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.companyInformation };

    if (name === "selectAll") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    }
    else if (name === "mailingAddress") {
      det[name] = checked;
      // automatically toggle all subfields
      det.mailingAddressLine1 = checked;
      det.mailingAddressLine2 = checked;
      det.mailingAddressLine3 = checked;
      det.mailingAddressCountry = checked;
      det.mailingAddressPostalCode = checked;
    }
    else if (name === "registeredAddress") {
      det[name] = checked;
      // automatically toggle all subfields
      det.registeredOfficeAddressLine1 = checked;
      det.registeredOfficeAddressLine2 = checked;
      det.registeredOfficeAddressLine3 = checked;
      det.registeredOfficeCountry = checked;
      det.registeredOfficePostalCode = checked;
    }
    else if (name === "companyProfile") {
      det[name] = checked;
      // automatically toggle all subfields
      det.issuedCapital = checked;
      det.paidUpCapital = checked;
      det.shareholdersEquities = checked;
      det.realEstateActivitiesID = checked;
      det.realEstateSpecification = checked;
      det.overseasOfficesID = checked;
      det.totalGroupAssetID = checked;
      det.employmentSizeID = checked;
      det.companyInterestsID = checked;
      det.howDidYouHearAboutUsID = checked;
    }
    else {
      det[name] = checked;
    }

    this.setState({ companyInformation: det });
  }



  handleChangeForCompanyPresence(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.compnanyPresence };

    if (name === "selectAll") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ compnanyPresence: det });
  }
  handleChangeForCompanyEndorserInformation(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.companyEndroserInfomation };

    if (name === "selectAll") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ companyEndroserInfomation: det });
  }

  handleChangeForRepresentatives(event) {
    const { name, checked } = event.target;

    if (name === "selectAll") {
      // Update "Select All (Representatives)"
      const newReps = { ...this.state.representatives };
      Object.keys(newReps).forEach((key) => {
        newReps[key] = checked;
      });

      // Update "Main Representative"
      const newMain = { ...this.state.mainepResentativesDetailes };
      Object.keys(newMain).forEach((key) => {
        newMain[key] = checked;
      });

      // Update "Alternative Representative"
      const newAlt = { ...this.state.alternativeRepresentativeDetailes };
      Object.keys(newAlt).forEach((key) => {
        newAlt[key] = checked;
      });

      // Update "Authorized Representative"
      const newAuth = { ...this.state.authorizedRepresentativeDetails };
      Object.keys(newAuth).forEach((key) => {
        newAuth[key] = checked;
      });

      // Set all in state
      this.setState({
        representatives: newReps,
        mainepResentativesDetailes: newMain,
        alternativeRepresentativeDetailes: newAlt,
        authorizedRepresentativeDetails: newAuth,
      });
    } else {
      // Single checkbox handling (if needed)
      const updatedReps = { ...this.state.representatives };
      updatedReps[name] = checked;
      this.setState({ representatives: updatedReps });
    }
  }

  handleChangeForMainRepresentative(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.mainepResentativesDetailes };

    if (name === "mainRepresentative") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ mainepResentativesDetailes: det });
  }

  handleChangeForAlternativeRepresentative(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.alternativeRepresentativeDetailes };

    if (name === "alterRepresentative") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ alternativeRepresentativeDetailes: det });
  }

  handleChangeForAuthorizedRepresentative(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.authorizedRepresentativeDetails };

    if (name === "authorizedRepresentative") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ authorizedRepresentativeDetails: det });
  }

  // handleChangeForResources(event) {
  //   const { name, checked } = event.target;
  //   let det = { ...this.state.resources };

  //   if (name === "selectAll") {
  //     Object.keys(det).forEach((key) => {
  //       det[key] = checked;
  //     });
  //   } else {
  //     det[name] = checked;
  //   }
  //   this.setState({ resources: det });
  // }

  handleChangeForResources(event) {
    const { name, checked } = event.target;

    if (name === "selectAll") {
      // Update main resource checkboxes
      const updatedResources = { ...this.state.resources };
      Object.keys(updatedResources).forEach((key) => {
        updatedResources[key] = checked;
      });

      // Update ordinaryProjectComplicatedDetailes
      const updatedOrdinaryCompleted = { ...this.state.ordinaryProjectComplicatedDetailes };
      Object.keys(updatedOrdinaryCompleted).forEach((key) => {
        updatedOrdinaryCompleted[key] = typeof updatedOrdinaryCompleted[key] === "boolean" ? checked : '';
      });

      // Update ordinaryProjectPipelineDetailes
      const updatedPipeline = { ...this.state.ordinaryProjectPipelineDetailes };
      Object.keys(updatedPipeline).forEach((key) => {
        updatedPipeline[key] = typeof updatedPipeline[key] === "boolean" ? checked : '';
      });

      // Update boardOfDirectiveDetailes
      const updatedBoard = { ...this.state.boardOfDirectiveDetailes };
      Object.keys(updatedBoard).forEach((key) => {
        updatedBoard[key] = checked;
      });

      // Update topManagementDetailes
      const updatedTop = { ...this.state.topManagementDetailes };
      Object.keys(updatedTop).forEach((key) => {
        updatedTop[key] = checked;
      });

      // Set all in state
      this.setState({
        resources: updatedResources,
        ordinaryProjectComplicatedDetailes: updatedOrdinaryCompleted,
        ordinaryProjectPipelineDetailes: updatedPipeline,
        boardOfDirectiveDetailes: updatedBoard,
        topManagementDetailes: updatedTop,
      });
    } else {
      // Handle individual checkbox toggle
      const updatedResources = { ...this.state.resources };
      updatedResources[name] = checked;
      this.setState({ resources: updatedResources });
    }
  }

  handleChangeForProjetComplicated(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.ordinaryProjectComplicatedDetailes };

    if (name === "isAllOrdinaryInformation") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ ordinaryProjectComplicatedDetailes: det });
  }


  handleChangeForProjetProgressPipeline(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.ordinaryProjectPipelineDetailes };

    if (name === "inProgressProjects") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ ordinaryProjectPipelineDetailes: det });
  }

  handleChangeForBoardOfDirectors(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.boardOfDirectiveDetailes };

    if (name === "isBoradOfDirective") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ boardOfDirectiveDetailes: det });
  }

  handleChangeForTopManagement(event) {
    const { name, checked } = event.target;
    let det = { ...this.state.topManagementDetailes };

    if (name === "isTopManagement") {
      Object.keys(det).forEach((key) => {
        det[key] = checked;
      });
    } else {
      det[name] = checked;
    }
    this.setState({ topManagementDetailes: det });
  }



  handleChangeDate = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "startDate") {
      this.setState({ startDate: value });
    }
    if (name === "endDate") {
      this.setState({ endDate: value });
    }
  };
  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.temp,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };


  handleChangeMultiDropdown(selected, identity) {
    let temp = { ...this.state.temp };
    if (identity === "MemberType") {
      const maxSelections = 30;
      const limitedSelections = selected.slice(0, maxSelections);

      temp.memberType = limitedSelections;

      this.setState({
        temp: temp,
        memberType: limitedSelections,
      }, () => {
        this.validateField("memberType");
      });

    }
    else if (identity === "MemberStatus") {
      const maxSelections = 30;
      const limitedSelections = selected.slice(0, maxSelections);

      temp.memberStatus = limitedSelections;

      this.setState({
        temp: temp,
        memberStatus: limitedSelections,
      }, () => {
        this.validateField("memberStatus");
      });

    }
    else if (identity === "Country") {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          Country: selected,
        },
      });
    }
    else if (identity === "totalGroupAsset") {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          totalGroupAsset: selected,
        },
      });
    }
    else if (identity === "marketInterest") {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          marketInterest: selected,
        },
      });
    }
    else if (identity === "businessInterest") {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          businessInterest: selected,
        },
      });
    }
  }

  render() {
    return (
      <div className="main-body-section">
        <div className="bg-white">
          <div className="heading-part pl-7 py-4 border-b">
            <div className="flex items-center justify-between">
              <h4 className="small-title font-bold theme-color">
                Member Information Report
              </h4>
            </div>
          </div>
          <div className="custom-card  mb-4 rounded-md">
            <div className="space-y-8 ">
              <div className="filter-info grid grid-cols-12 gap-6">
                <div className="filter-types col-span-12 lg:col-span-6">
                  <div className="pl-8 items-center border-gray-400">
                    <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                      Member Status<span className="text-[#C00000]">*</span>
                    </h2>
                    <div className="w-full">
                      <MultiSelectDropdown
                        drpIdentity="MemberStatus"
                        options={this.state.status}
                        isMulti
                        closeMenuOnSelect={false}
                        components={{ Option }}
                        allowSelectAll={true}
                        hideSelectedOptions={false}
                        onChange={this.handleChangeMultiDropdown.bind(this)}
                        value={this.state.temp.memberStatus}
                      />
                    </div>
                    <ValidationText error={this.state.validState.error.memberStatus} />
                  </div>
                </div>

                <div className="filter-types col-span-12 lg:col-span-6 ">
                  <div className="pl-8 items-center border-gray-400">
                    <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                      Member Type<span className="text-[#C00000]">*</span>
                    </h2>
                    <div className="w-full">
                      {/* <DropdownSelect
                        drpIdentity="MemberType"
                        optionArray={this.state.membershipType}
                        allowSelectAll={false}
                        setFilterParameters={this.handleChange}
                        value={this.state.selectedFilters.MemberType}
                      />
                    </div> */}
                      <MultiSelectDropdown
                        drpIdentity="MemberType"
                        options={this.state.membershipType}
                        isMulti
                        closeMenuOnSelect={false}
                        components={{ Option }}
                        hideSelectedOptions={false}
                        onChange={this.handleChangeMultiDropdown.bind(this)}
                        allowSelectAll={true}
                        value={this.state.temp.memberType}

                      />
                    </div>
                    <ValidationText error={this.state.validState.error.memberType} />
                  </div>
                </div>
              </div>
            </div>

            <div className="filter-info grid grid-cols-12 gap-6 mt-7">
              {/* <div className="filter-types col-span-12 lg:col-span-6">
                <div className="pl-8 items-center border-gray-400">
                  <h2 className="text-xl font-medium theme-color ">
                    Membership Admission From
                  </h2>
                  <div className="w-full">
                    <input
                      id="startDate"
                      name="startDate"
                      className="date-pickers form-input w-full rounded-none shadow-red py-3 text-lg"
                      value={moment(this.state.startDate).format("yyyy-MM-DD")}
                      onChange={(event) => this.handleChangeDate(event)}
                      type="date"
                    />
                  </div>
                </div>
              </div>

              <div className="filter-types col-span-12 lg:col-span-6">
                <div className="pl-8 items-center border-gray-400">
                  <h2 className="text-xl font-medium theme-color">
                    Membership Admission To
                  </h2>
                  <div className="w-full">
                    <input
                      id="endDate"
                      name="endDate"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(this.state.endDate).format("yyyy-MM-DD")}
                      onChange={(event) => this.handleChangeDate(event)}
                      type="date"
                    />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          {/* <div className="heading-part pl-7 py-4 border-b">
            <div className="flex items-center justify-between">
              <h4 className="small-title font-bold theme-color">Filters</h4>
            </div>
          </div>
          <div className="custom-card  mb-4 rounded-md">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6">
                <div className="pl-8 border-[#757575]">
                  <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                    Country
                  </h2>
                  <MultiSelectDropdown
                    drpIdentity="Country"
                    options={this.state.countries}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ Option }}
                    hideSelectedOptions={false}
                    onChange={this.handleChangeMultiDropdown.bind(this)}
                    allowSelectAll={true}
                    value={this.state.selectedFilters.Country}
                  />
                </div>
              </div>

              <div className="col-span-6">
                <div className="pl-8 border-[#757575]">
                  <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                    Total Group Asset
                  </h2>
                  <MultiSelectDropdown
                    drpIdentity="totalGroupAsset"
                    options={this.state.groupAsset}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ Option }}
                    hideSelectedOptions={false}
                    onChange={this.handleChangeMultiDropdown.bind(this)}
                    allowSelectAll={true}
                    value={this.state.selectedFilters.totalGroupAsset}
                  />
                </div>
              </div>
              <div className="col-span-6">
                <div className="pl-8 border-[#757575]">
                  <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                    Business Interest
                  </h2>
                  <MultiSelectDropdown
                    drpIdentity="businessInterest"
                    options={this.state.businessInterest}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ Option }}
                    hideSelectedOptions={false}
                    onChange={this.handleChangeMultiDropdown.bind(this)}
                    allowSelectAll={true}
                    value={this.state.selectedFilters.businessInterest}
                  />
                </div>
              </div>
              <div className="col-span-6">
                <div className="pl-8 border-[#757575]">
                  <h2 className="text-xl font-medium theme-color whitespace-nowrap mr-4">
                    Market Interest
                  </h2>
                  <MultiSelectDropdown
                    drpIdentity="marketInterest"
                    options={this.state.marketInterest}
                    isMulti
                    closeMenuOnSelect={false}
                    components={{ Option }}
                    hideSelectedOptions={false}
                    onChange={this.handleChangeMultiDropdown.bind(this)}
                    allowSelectAll={true}
                    value={this.state.selectedFilters.marketInterest}
                  />
                </div>
              </div>

              <div className="filter-types col-span-12 lg:col-span-6">
                <div className="pl-8 items-center border-gray-400">
                  <h2 className="text-xl font-medium theme-color ">
                    Membership Admission From
                  </h2>
                  <div className="w-full">
                    <input
                      id="startDate"
                      name="startDate"
                      className="date-pickers form-input w-full rounded-none shadow-red py-3 text-lg"
                      value={moment(this.state.startDate).format("yyyy-MM-DD")}
                      onChange={(event) => this.handleChangeDate(event)}
                      type="date"
                    />
                  </div>
                </div>
              </div>

              <div className="filter-types col-span-12 lg:col-span-6">
                <div className="pl-8 items-center border-gray-400">
                  <h2 className="text-xl font-medium theme-color">
                    Membership Admission To
                  </h2>
                  <div className="w-full">
                    <input
                      id="endDate"
                      name="endDate"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(this.state.endDate).format("yyyy-MM-DD")}
                      onChange={(event) => this.handleChangeDate(event)}
                      type="date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="heading-part pl-7 py-4 border-b">
            <div className="flex items-center justify-between">
              <h4 className="small-title font-bold theme-color">
                Selected Filters
              </h4>
            </div>
          </div>

          <div className="filter-types custom-card mb-4 rounded-md">
            <div className="grid grid-cols-12 gap-4">
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="selectAll"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      value={
                        this.state.companyInformation.isAllCompanyInformation
                      }
                    />
                    <span className="text-xl theme-color ml-4">
                      Select All (Company Information)
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="companyName"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.companyName}
                    />
                    <span className="text-xl theme-color ml-4">
                      Company Name
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="uen"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.uen}
                    />
                    <span className="text-xl theme-color ml-4">UEN</span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="statusId"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.statusId}
                    />
                    <span className="text-xl theme-color ml-4">
                      Membership Status
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="mailingAddress"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.mailingAddress}
                    />
                    <span className="text-xl theme-color ml-4">
                      Mailing Address
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="registeredAddress"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.registeredAddress}
                    />
                    <span className="text-xl theme-color ml-4">
                      Registered Address
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="membershipTypeId"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.membershipTypeId}
                    />
                    <span className="text-xl theme-color ml-4">
                      Membership Type
                    </span>
                  </label>
                </div>
              </div>
              {/* <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="postalCode"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.postalCode}
                    />
                    <span className="text-xl theme-color ml-4">
                      Postal Code
                    </span>
                  </label>
                </div>
              </div> */}

              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="companyTelephone"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={
                        this.state.companyInformation.companyTelephone
                      }
                    />
                    <span className="text-xl theme-color ml-4">
                      Company Tel
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="companyAdminEmail"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={
                        this.state.companyInformation.companyAdminEmail
                      }
                    />
                    <span className="text-xl theme-color ml-4">
                      Company Admin Email
                    </span>
                  </label>
                </div>
              </div>
              {/* <div className=' col-span-4'>
                                <div className="m-3">
                                    <label className="flex items-center">
                                        <input type="checkbox" className="form-checkbox"
                                            name="companyFax"
                                            onChange={(event) => this.handleChangeForCompanyInformation(event)}
                                            checked={this.state.companyInformation.companyFax} />
                                        <span className="text-xl theme-color ml-4">Company Fax</span>
                                    </label>
                                </div>
                            </div> */}
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="incorporationDate"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.incorporationDate}
                    />
                    <span className="text-xl theme-color ml-4">
                      Date Of Incorporation
                    </span>
                  </label>
                </div>
              </div>
              {/* <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="paidUpCapital"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.paidUpCapital}
                    />
                    <span className="text-xl theme-color ml-4">
                      Paidup Capital
                    </span>
                  </label>
                </div>
              </div> */}

              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="organisationWebsite"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={
                        this.state.companyInformation.organisationWebsite
                      }
                    />
                    <span className="text-xl theme-color ml-4">
                      Company Website
                    </span>
                  </label>
                </div>
              </div>

              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="employmentSize"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.employmentSize}
                    />
                    <span className="text-xl theme-color ml-4">
                      No Of Employees
                    </span>
                  </label>
                </div>
              </div>
              <div className="col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="countries"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.countries}
                    />
                    <span className="text-xl theme-color ml-4">Countries</span>
                  </label>
                </div>
              </div>

              <div className="col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="companyProfile"
                      onChange={(event) =>
                        this.handleChangeForCompanyInformation(event)
                      }
                      checked={this.state.companyInformation.issuedCapital}
                    />
                    <span className="text-xl theme-color ml-4">Company Profile</span>
                  </label>
                </div>
              </div>

            </div>

          </div>
          <div className="filter-types custom-card mb-4 rounded-md">
            <div className="grid grid-cols-12 gap-4">
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="selectAll"
                      onChange={(event) =>
                        this.handleChangeForRepresentatives(event)
                      }
                      value={this.state.representatives}
                    />
                    <span className="text-xl theme-color ml-4">
                      Select All (Representatives)
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="mainRepresentative"
                      onChange={(event) =>
                        this.handleChangeForMainRepresentative(event)
                      }
                      checked={this.state.mainepResentativesDetailes.isAllCompanyInformation}
                    />
                    <span className="text-xl theme-color ml-4">Main Representative</span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="alterRepresentative"
                      onChange={(event) =>
                        this.handleChangeForAlternativeRepresentative(event)
                      }
                      checked={this.state.alternativeRepresentativeDetailes.alterRepresentative}
                    />
                    <span className="text-xl theme-color ml-4">Alternative Representative</span>
                  </label>
                </div>
              </div>
              {/* <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="authorizedRepresentative"
                      onChange={(event) =>
                        this.handleChangeForAuthorizedRepresentative(event)
                      }
                      checked={this.state.authorizedRepresentativeDetails.authorizedRepresentative}
                    />
                    <span className="text-xl theme-color ml-4">Authorized Representative</span>
                  </label>
                </div>
              </div>  */}
            </div>
          </div>
          <div className="filter-types custom-card mb-4 rounded-md">
            <div className="grid grid-cols-12 gap-4">
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="selectAll"
                      onChange={(event) =>
                        this.handleChangeForResources(event)
                      }
                      value={this.state.resources.isAllResources}
                    />
                    <span className="text-xl theme-color ml-4">
                      Select All
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="isAllOrdinaryInformation"
                      onChange={(event) =>
                        this.handleChangeForProjetComplicated(event)
                      }
                      checked={this.state.ordinaryProjectComplicatedDetailes.isAllOrdinaryInformation}
                    />
                    <span className="text-xl theme-color ml-4">Ordinary - Projects Completed</span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="inProgressProjects"
                      onChange={(event) =>
                        this.handleChangeForProjetProgressPipeline(event)
                      }
                      checked={this.state.ordinaryProjectPipelineDetailes.inProgressProjects}
                    />
                    <span className="text-xl theme-color ml-4">Ordinary - Projects In Progress/Pipeline
                    </span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="isBoradOfDirective"
                      onChange={(event) =>
                        this.handleChangeForBoardOfDirectors(event)
                      }
                      checked={this.state.boardOfDirectiveDetailes.isBoradOfDirective}
                    />
                    <span className="text-xl theme-color ml-4">Board of Directors</span>
                  </label>
                </div>
              </div>
              <div className=" col-span-4">
                <div className="m-3">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name="isTopManagement"
                      onChange={(event) =>
                        this.handleChangeForTopManagement(event)
                      }
                      checked={this.state.topManagementDetailes.isTopManagement}
                    />
                    <span className="text-xl theme-color ml-4">Top Management</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="xl:col-span-2 lg:col-span-2 col-span-12">
          <div className="flex items-end justify-end h-full pb-1">
            <div className="flex">
              {
                this.state.isLoading ? (<ButtonLoader />) :
                  (
                    <button
                      className="btn btn-red text-white w-[180px] h-[50px] flex items-center justify-center gap-2 text-xl font-semibold tracking-normal"
                      onClick={() => this.getAllMembersReportsDetail()}
                    >
                      <span className="text-xl text-white font-semibold tracking-normal">
                        Export
                      </span>

                    </button>
                  )
              }

            </div>
          </div>
        </div>
      </div>
    );
  }
}


